import React from 'react';
import SectionNumberBadge from './SectionNumberBadge';

interface Props {
  subjective: string;
  objective: string;
  assessment: string;
  plan: string;
  onChange: (field: 'subjective' | 'objective' | 'assessment' | 'plan', value: string) => void;
  sectionNumber?: string;
}

export default function SOAPFields({ subjective, objective, assessment, plan, onChange, sectionNumber }: Props) {
  return (
    <div className="card">
      <div className="card-body">
        <h4 className="card-title">{sectionNumber && <SectionNumberBadge number={sectionNumber} />}<i className="fa fa-clipboard me-2"></i>SOAP - Nota Estructurada</h4>

        <div className="row mt-3">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Subjetivo (S)</label>
              <textarea
                className="form-control"
                rows={3}
                value={subjective}
                onChange={(e) => onChange('subjective', e.target.value)}
                placeholder="Manifestaciones del paciente, síntomas referidos..."
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Objetivo (O)</label>
              <textarea
                className="form-control"
                rows={3}
                value={objective}
                onChange={(e) => onChange('objective', e.target.value)}
                placeholder="Hallazgos al examen físico, signos vitales..."
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Evaluación (A)</label>
              <textarea
                className="form-control"
                rows={3}
                value={assessment}
                onChange={(e) => onChange('assessment', e.target.value)}
                placeholder="Diagnóstico, impresión clínica..."
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Plan (P)</label>
              <textarea
                className="form-control"
                rows={3}
                value={plan}
                onChange={(e) => onChange('plan', e.target.value)}
                placeholder="Tratamiento, órdenes, seguimiento..."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
